import { render } from "./MarketingMethod.vue?vue&type=template&id=108a9efa"
import script from "./MarketingMethod.vue?vue&type=script&lang=js"
export * from "./MarketingMethod.vue?vue&type=script&lang=js"

import "./MarketingMethod.vue?vue&type=style&index=0&id=108a9efa&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__